import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { ArchivosCreditosService } from "../../../../../services/archivos-creditos.service";
import { ArchivosAvalesService } from "../../../../../services/archivos-avales.service";
import { HelpersService } from '../../../../../services/tools/helpers.service';

@Component({
  selector: 'archivos-aval',
  templateUrl: './archivos-aval.component.html'
})
export class ArchivosAvalComponent implements OnInit {

    @Input() public idCreditos: number = null;
    @Input() public idAval: number = null;
    @Input() public isEditable: boolean = false;
    @Input() public tipoArchivos: string = null;
    @Output() public onClientUpdated:EventEmitter<string> = new EventEmitter;
    //Cliente form
    public listArchivos: any = [];
    public uploadingFile : boolean = false;
    public errors:any = {};
    public idTipoArchivos : number = 0;
    public formId: number = 0;

    constructor(
    //private archivosService: ArchivosCreditosService,
    private helperService: HelpersService,
    private archivosService: ArchivosAvalesService
    ){
    }

    ngOnInit() {
    //formId se asigna con un valor 'unico' para utilizar como id, en algún coponente del front
    this.formId = + new Date();
    }

    public reloadListaArchivos(){
        if(this.idAval){
        this.getArchivos(this.idAval);    
        }
    }

    private getArchivos(idAval : number){
    this.archivosService.get(idAval).subscribe(
        (response)=>
        {
        const archivos = response.json().content;
        this.listArchivos = archivos;
        }, error =>
        {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        
        if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors); 
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        }
    );
    }

    /**
     * Upload files
     */
    public uploadFile(event) {
        //Show spinner
        this.uploadingFile = true;

        let fileInfo = 
        {
        idAval : this.idAval,
        tipo: this.idTipoArchivos,
        descripcion: ''
        };

        let observableResponse = this.archivosService.save(event, fileInfo);

        if(!observableResponse){
        //Si al hacer el Upload del archivo se cancela la carga, cae en este escenario 
        this.uploadingFile = false;
        return;
        }

        observableResponse.subscribe(
            (response)=>
            {
                let archivo = response.json().content;
                //Se agrega la info del nuevo archivo a la lista para que se muestre en el formulario
                this.listArchivos.push(archivo);
                
                //Hide spinner
                this.uploadingFile = false;

                //Notify result
                this.helperService.notification('Archivo agregado', 'Se ha agregado exitosamente el archivo', 'success');
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);
        
                if(error.status == 400) {
                this.helperService.setBackendErrors(error.json().content, this.errors);
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );
    }

    public delete(idFile : number){
        this.archivosService.delete(idFile).subscribe(
            (response)=>
            {
                //Eliminar el archivo de la lista, para que no se muestre en el formulario
                let archivos = this.listArchivos;
                archivos.forEach(function(archivo, index) {
                if(archivo.id === idFile){
                    archivos.splice(index, 1);
                }
                });

                this.helperService.notification('Archivo eliminado', 'Se ha eliminado exitosamente el archivo ', 'success');

            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    public downloadFile(idFile : any) {
        this.archivosService.getFile(idFile).subscribe(
        (response)=>
        {
            const fileUrl = window.URL.createObjectURL(response.blob());
            //Muestra el archivo en una nueva ventana
            window.open(fileUrl);
        }, error =>
        {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
        }
        );
    }


    public updateArchivos(){
        this.archivosService.update(this.listArchivos).subscribe(
        (response)=>
        {
            const archivos = response.json().content;
            this.helperService.notification('Archivos actualizados', 'Se ha actualizado la información de los archivos ', 'success');
        }, error =>
        {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
            
            if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
        }
        );
    }

    /**
     * Cuando se agrega un archivo antes de que exista el Aval. 
     * Se utiliza este metodo para asignar el IdAval, posterior a que este ha sido creado
     */
    public setIdAval(idAval: number){
        let archivos = this.listArchivos;

        //Se aplica este cambio cuando se agregaron archivos al Aval
        if(archivos.length > 0){
            archivos.forEach(function(archivo: any) {
                if(!archivo.idAval){
                    archivo.idAval = idAval;
                }
            });
    
            this.updateArchivos();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/creditos/components/formulario-aval/components/archivos-aval/archivos-aval.component.ts